import type {AxiosRequestConfig} from 'axios';
import {Webhook} from './interface';

export class GetWebhooksRequestBuilder {
  private readonly webhookRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/webhooks',
    params: {},
  };

  id(id: number) {
    this.webhookRequest.url = `/webhooks/${id}`;
    return this;
  }

  params(params: object) {
    this.webhookRequest.params = params;
    return this;
  }

  build() {
    return this.webhookRequest;
  }
}

export class GetWebhooksCountRequestBuilder {
  private readonly webhookRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/webhooks/count',
  };

  params(params: object) {
    this.webhookRequest.params = params;
    return this;
  }

  build() {
    return this.webhookRequest;
  }
}

export class CreateWebhookRequestBuilder {
  private readonly webhookRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/webhooks',
    data: {},
  };

  data(data: Webhook) {
    this.webhookRequest.data = data;
    return this;
  }

  build() {
    return this.webhookRequest;
  }
}

export class UpdateWebhookRequestBuilder {
  private readonly webhookRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/webhooks',
    data: {},
  };
  data(body: Webhook) {
    this.webhookRequest.data = body;
    return this;
  }
  build() {
    return this.webhookRequest;
  }
}

export class DeleteWebhookRequestBuilder {
  private readonly webhookRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '/webhooks',
    data: {},
  };
  id(id: number) {
    this.webhookRequest.url = `/webhooks/${id}`;
    return this;
  }
  build() {
    return this.webhookRequest;
  }
}
